import React from "react";
import { Link } from "react-router-dom";
import { QrCode } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const BrandMark = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="brand-home-link">
    <span className="grid h-8 w-8 place-items-center rounded-sm bg-primary text-white">
      <QrCode className="h-5 w-5" />
    </span>
    <span className="font-display text-lg tracking-tight sm:text-xl">
      <span className="font-semibold text-foreground">ExpoEvent</span>
      <span className="font-bold text-primary">Hub</span>
      <span className="font-semibold text-foreground">.com</span>
    </span>
  </Link>
);

export const VendorAvatar = ({ vendor, size = 56 }: { vendor: any; size?: number }) => {
  const logo = fileUrl(vendor?.logo_path);
  const initials = (vendor?.name || "?").split(/\s+/).filter((w: string) => /^[a-z0-9]/i.test(w)).map((w: string) => w[0]).slice(0, 2).join("");
  return logo ? (
    <img src={logo} alt={vendor?.name} style={{ width: size, height: size }} className="rounded-sm object-cover ring-1 ring-black/5" />
  ) : (
    <div
      style={{ width: size, height: size, background: vendor?.brand_color || "#E05A33" }}
      className="grid place-items-center rounded-sm font-display text-lg font-semibold text-white"
    >
      {initials}
    </div>
  );
};
